import PropTypes from "prop-types"

const ListTitle = ({ description, icon, iconColor, title }) => {
  const DynamicIcon = icon || null

  return (
    <div className="flex items-center justify-between">
      <div className='flex items-center gap-3 mb-1'>
        <DynamicIcon icon={icon} className={`shrink-0 ${iconColor} h-12 w-12`} />
  
        <div>
          <h2 className="text-lg font-semibold">{title}</h2>
          <p className="text-base text-content2-foreground">{description}</p>
        </div>
      </div>
    </div>
  )
}

ListTitle.propTypes = {
  description: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  iconColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default ListTitle